import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { Button, Form, Modal } from 'aui';
import Content from './Content';

type TProps = {
  visible?: boolean;
  onCancel: () => void;
};

const ExportModal = (props: TProps) => {
  const { visible, onCancel } = props;
  const [form] = Form.useForm();
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  return (
    <Modal
      destroyOnClose
      open={visible}
      onCancel={onCancel}
      title={clientI18n('onlineShare.export')}
      width={600}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            form.submit();
          }}
        >
          {clientI18n('export')}
        </Button>,
      ]}
    >
      <Content form={form} />
    </Modal>
  );
};

export default ExportModal;
